module.exports = "<span>\n    <span *ngIf=\"startDate\">\n        {{ startDate | timeFilter: setStartDateFilter() }}\n        <span *ngIf=\"startDate != finishDate\">\n             - <span class=\"text-nowrap\">{{ finishDate | timeFilter: fromQuote ? 'long' : 'medium' }}</span>\n        </span>\n    </span>\n    <span *ngIf=\"!startDate\">No date</span>\n</span>"


//////////////////
// WEBPACK FOOTER
// ./shared/components/common/main-shoot-date/main-shoot-date.html
// module id = ./shared/components/common/main-shoot-date/main-shoot-date.html
// module chunks = 0